import script from "./InquiryDetailQuotesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailQuotesSection.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailQuotesSection.vue?vue&type=style&index=0&id=882f9674&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882f9674"]])

export default __exports__